(function(){
  Array.from(document.querySelectorAll(".mt-image-list__wrapper")).forEach((container) => {
    let itemlist = container.querySelector(".mt-image-list__items");
    let items = itemlist.querySelectorAll(".mt-image-list__item");

    let childList = container.querySelector(".mt-image-list__child-wrapper");
    let childs = childList.querySelectorAll(".mt-image-list__childs");
    items.forEach((item) => {
      let index = item.getAttribute("data-index");
      item.addEventListener('click', (e) => {
        items.forEach((curItem) => {
          if(curItem == item){
            curItem.classList.add("selected");
          }else{
            curItem.classList.remove("selected");
          }
        });
        childs.forEach((curChild) => {
          if(curChild.getAttribute("data-index") == index){
            curChild.classList.add("selected");
          }else{
            curChild.classList.remove("selected");
          }
        });
      });   
    });
  });

  
})();